export interface AudioItem {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  duration: string;
  format: string;
  icon: string;
  previewUrl: string;
  previewDuration: string;
  benefits: string[];
}

export const audioItems: AudioItem[] = [
  {
    id: 'crianca-interior',
    title: 'Áudio de Cura da Criança Interior',
    subtitle: 'Reconecte-se com sua essência mais pura',
    description:
      'Este áudio foi criado com frequências sonoras cuidadosamente calibradas para acessar memórias da infância e liberar bloqueios emocionais profundos. Através de sons binaurais e afirmações positivas, você vai ressignificar experiências passadas e resgatar a leveza da sua criança interior. Ideal para quem sente que traumas antigos ainda limitam sua vida adulta.',
    duration: '28 minutos',
    format: 'MP3 - 320kbps',
    icon: 'ri-heart-pulse-line',
    previewUrl: 'https://terapia.nxhost.com.br/curainterior40.mp3',
    previewDuration: '1:53',
    benefits: [
      'Libera traumas da infância',
      'Reduz ansiedade e medos',
      'Aumenta a autoestima',
      'Promove paz interior',
    ],
  },
  {
    id: 'limpeza-relacionamentos',
    title: 'Áudio de Limpeza de Relacionamentos Passados',
    subtitle: 'Liberte-se dos laços que já não servem mais',
    description:
      'Relacionamentos passados podem deixar marcas energéticas que impedem novas conexões saudáveis. Este áudio utiliza técnicas de desvinculação energética combinadas com frequências de limpeza para cortar cordões emocionais, liberar mágoas e abrir espaço para relações mais leves e autênticas na sua vida.',
    duration: '46 minutos',
    format: 'MP3 - 320kbps',
    icon: 'ri-links-line',
    previewUrl: 'https://terapia.nxhost.com.br/sessaorelacionamento40.mp3',
    previewDuration: '2:40',
    benefits: [
      'Corta laços energéticos',
      'Libera mágoas e ressentimentos',
      'Abre espaço para novos amores',
      'Restaura equilíbrio emocional',
    ],
  },
  {
    id: 'prosperidade',
    title: 'Áudio de Prosperidade e Abundância',
    subtitle: 'Ative a frequência da abundância na sua vida',
    description:
      'A prosperidade é uma vibração, e este áudio foi desenvolvido para sintonizar sua mente com a frequência da abundância. Combinando ondas Theta, afirmações de riqueza e sons da natureza, você reprograma crenças limitantes sobre dinheiro e abre os caminhos para prosperidade em todas as áreas: financeira, profissional, emocional e espiritual.',
    duration: '47 minutos',
    format: 'MP3 - 320kbps',
    icon: 'ri-money-dollar-circle-line',
    previewUrl: 'https://terapia.nxhost.com.br/sessaoriqueza40.mp3',
    previewDuration: '1:15',
    benefits: [
      'Reprograma crenças sobre dinheiro',
      'Atrai oportunidades financeiras',
      'Expande mentalidade de abundância',
      'Aumenta autoconfiança profissional',
    ],
  },
];

export interface Testimonial {
  id: string;
  name: string;
  initials: string;
  location: string;
  text: string;
  audio: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 'mariana',
    name: 'Mariana S.',
    initials: 'M',
    location: 'São Paulo, SP',
    text: 'Eu não esperava uma transformação tão rápida. O áudio da criança interior me fez chorar de alívio nos primeiros minutos. Senti como se um peso de anos tivesse sido tirado dos meus ombros. Hoje me sinto mais leve, mais confiante e finalmente em paz com meu passado.',
    audio: 'Cura da Criança Interior',
  },
  {
    id: 'carlos',
    name: 'Carlos E.',
    initials: 'C',
    location: 'Rio de Janeiro, RJ',
    text: 'Comprei o pacote completo e foi o melhor investimento que fiz este ano. O áudio de prosperidade mudou completamente minha relação com dinheiro. Em 3 semanas, fechei dois contratos que estavam parados há meses. A energia mudou de verdade!',
    audio: 'Pacote Completo',
  },
  {
    id: 'fernanda',
    name: 'Fernanda L.',
    initials: 'F',
    location: 'Belo Horizonte, MG',
    text: 'Depois de um divórcio difícil, o áudio de limpeza de relacionamentos foi essencial para minha recuperação. As frequências realmente ajudam a cortar aqueles laços energéticos. Agora me sinto pronta para novos começos. Recomendo demais!',
    audio: 'Limpeza de Relacionamentos Passados',
  },
  {
    id: 'rafael',
    name: 'Rafael M.',
    initials: 'R',
    location: 'Curitiba, PR',
    text: 'Sempre fui cético com esse tipo de coisa, mas resolvi testar por indicação de uma amiga. O áudio de prosperidade me surpreendeu — não é mágica, é uma reprogramação mental que realmente funciona. Minha produtividade e foco melhoraram muito.',
    audio: 'Prosperidade e Abundância',
  },
];

export interface Benefit {
  id: string;
  icon: string;
  title: string;
  description: string;
}

export const benefits: Benefit[] = [
  {
    id: 'emocional',
    icon: 'ri-heart-line',
    title: 'Reconexão Emocional',
    description: 'Restabeleça o contato com suas emoções mais genuínas e aprenda a acolhê-las sem julgamento.',
  },
  {
    id: 'passado',
    icon: 'ri-shield-check-line',
    title: 'Libertação do Passado',
    description: 'Solte padrões antigos, mágoas guardadas e ciclos repetitivos que impedem seu crescimento.',
  },
  {
    id: 'prosperidade',
    icon: 'ri-star-line',
    title: 'Atração de Prosperidade',
    description: 'Eleve sua vibração energética para sintonizar com oportunidades de abundância em todas as áreas.',
  },
  {
    id: 'sono',
    icon: 'ri-moon-line',
    title: 'Sono Restaurador',
    description: 'As frequências sonoras induzem um estado de relaxamento profundo, melhorando a qualidade do seu sono.',
  },
  {
    id: 'clareza',
    icon: 'ri-brain-line',
    title: 'Clareza Mental',
    description: 'Reduza o ruído mental, ganhe foco e tome decisões com mais segurança e confiança.',
  },
  {
    id: 'equilibrio',
    icon: 'ri-flower-line',
    title: 'Equilíbrio Energético',
    description: 'Harmonize seus centros energéticos e sinta mais vitalidade, disposição e bem-estar no dia a dia.',
  },
];

export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: 'formato',
    question: 'Em qual formato recebo os áudios?',
    answer:
      'Todos os áudios são em formato MP3 de alta qualidade (320kbps), compatível com qualquer dispositivo: celular Android e iPhone, computador, tablet e smart speakers. Ouça direto no navegador, sem precisar instalar nada.',
  },
  {
    id: 'acesso',
    question: 'Como acesso os áudios após a compra?',
    answer:
      'Após a confirmação do pagamento via Hotmart, você recebe acesso imediato aos áudios através da plataforma. Lá você pode ouvir todos os 3 áudios online, pelo navegador, sem precisar baixar nada. Seu acesso fica disponível por 1 ano inteiro.',
  },
  {
    id: 'tempo',
    question: 'Quanto tempo leva para receber após o pagamento?',
    answer:
      'A confirmação do pagamento via Hotmart é instantânea tanto para PIX quanto para cartão. Assim que aprovado, você recebe acesso imediato aos seus áudios em poucos segundos.',
  },
  {
    id: 'reembolso',
    question: 'Posso pedir reembolso se não gostar?',
    answer:
      'Sim! Você tem 7 dias de garantia incondicional. Se por qualquer motivo os áudios não atenderem suas expectativas, a Hotmart devolve 100% do valor pago. Basta solicitar o reembolso diretamente pela plataforma.',
  },
  {
    id: 'dispositivo',
    question: 'Os áudios funcionam em qualquer dispositivo?',
    answer:
      'Sim! Você pode ouvir pelo navegador em celulares (Android e iPhone), computadores (Windows, Mac, Linux), tablets e smart TVs. Basta acessar sua conta e dar play — funciona em qualquer lugar com internet.',
  },
  {
    id: 'duracao',
    question: 'Por quanto tempo tenho acesso aos áudios?',
    answer:
      'O acesso é por 1 ano após a compra. Durante 12 meses você pode ouvir os áudios quantas vezes quiser, de qualquer dispositivo, sem ocupar espaço com arquivos. É só entrar na sua conta e escutar.',
  },
  {
    id: 'frequencia',
    question: 'Qual a frequência ideal para ouvir os áudios?',
    answer:
      'Recomendamos ouvir uma vez ao dia, preferencialmente em um ambiente tranquilo com fones de ouvido para melhor experiência das frequências binaurais. Cada pessoa responde de forma única, mas os melhores resultados vêm com consistência.',
  },
];